module.exports = __webpack_public_path__ + "static/img/yimi.cea3dcca.png";